import React from 'react'

const Quotes = (props) => {
    return (
        <div style={{ textAlign: "center", backgroundColor: "wheat" }}>
            <i><b style={{ color:"#003f03"}}>{props.text}</b></i>
            <p style={{ textAlign: "center" }}>- {props.author}</p>
        </div>
    )
}

export default Quotes